import {
  GOOGLE_SEARCH_TEXT_COOKIE_KEY,
  LANDING_PAGE_COOKIE_KEY,
  REFERRER_COOKIE_KEY,
} from '~/scripts/constants';
import { getOrStoreCookie } from './storage';

export function getOriginalLandingPage(): string {
  return getOrStoreCookie(LANDING_PAGE_COOKIE_KEY, window.location.href);
}

export function getOriginalReferer(): string {
  return getOrStoreCookie(REFERRER_COOKIE_KEY, document.referrer);
}

export function getOriginalGoogleSearchText(): string {
  return getOrStoreCookie(
    GOOGLE_SEARCH_TEXT_COOKIE_KEY,
    (window.location.hash.match(/^#:~:text=(.+)/) || [])[1] || ''
  );
}
